import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import LockOutlined from '@mui/icons-material/LockOutlined';
import VpnKeyOutlined from '@mui/icons-material/VpnKeyOutlined';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

const SETUP_STEPS = [
  {
    Icon: VpnKeyOutlined,
    titleKey: 'administration.integration.command_alkon.setup_steps.request',
    descriptionKey:
      'administration.integration.command_alkon.setup_steps.request_description',
  },
  {
    Icon: LockOutlined,
    titleKey: 'administration.integration.command_alkon.setup_steps.verify',
    descriptionKey:
      'administration.integration.command_alkon.setup_steps.verify_description',
  },
  {
    Icon: LocalShippingOutlined,
    titleKey: 'administration.integration.command_alkon.setup_steps.map',
    descriptionKey:
      'administration.integration.command_alkon.setup_steps.map_description',
  },
] as const;

const CommandAlkonSetupSteps = () => {
  const theme = useTheme();

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 3 }}>
      {SETUP_STEPS.map(({ Icon, titleKey, descriptionKey }, index) => (
        <Box
          key={titleKey}
          sx={{
            backgroundColor: theme.semantic.surfaceRaised,
            border: `1px solid ${theme.brandV2.colors.treadGray7}`,
            borderRadius: 2,
            flex: 1,
            p: 2,
          }}
        >
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mb: 1 }}>
            <Box
              sx={{
                alignItems: 'center',
                backgroundColor: theme.brandV2.colors.treadGray1,
                borderRadius: '50%',
                color: theme.semantic.textInverse,
                display: 'flex',
                flexShrink: 0,
                fontSize: 12,
                fontWeight: 700,
                height: 22,
                justifyContent: 'center',
                width: 22,
              }}
            >
              {index + 1}
            </Box>
            <Icon sx={{ color: theme.brandV2.colors.treadGray3, fontSize: 18 }} />
            <Typography
              variant="body2"
              sx={{ color: theme.brandV2.colors.treadGray1, fontWeight: 600 }}
            >
              {t(titleKey)}
            </Typography>
          </Stack>
          <Typography variant="body2" sx={{ color: theme.brandV2.colors.treadGray2 }}>
            {t(descriptionKey)}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};

export default CommandAlkonSetupSteps;
